// 1. Librerías externas
import React, { useMemo } from "react";

// 2. Iconos
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import SensorsOffRoundedIcon from "@mui/icons-material/SensorsOffRounded";
import PowerIcon from "@mui/icons-material/Power";
import BatterySaverIcon from "@mui/icons-material/BatterySaver";

// 3. Componentes internos
import CustomTooltip from "../ui/CustomTooltip";

// 4. Estilos
import "./QuadrantDetail.css";

// 5. Constantes
const DEFAULT_PRESS_RECOVERY = 3.5;
const DEFAULT_PRESS_OFF = 4.2;

// función utilitaria
const formatNumber = (value) => {
  if (value === null || isNaN(value)) return null;

  const num = Number(value);
  const decimals = (num.toString().split(".")[1] || "").length;

  return decimals > 2 ? num.toFixed(2) : num;
};


function QuadrantDetail({ can, translate, selectedCenter }) {

  // const pressRecovery = DEFAULT_PRESS_RECOVERY;
  // const pressOff = DEFAULT_PRESS_OFF;
  const pressRecovery = can?.Umbral_Press_stop ||  DEFAULT_PRESS_RECOVERY;
  const pressOff = can?.Umbral_Press_start || DEFAULT_PRESS_OFF;
  const tieneDatosCompletos = selectedCenter?.centro !== 'hueihue';
  // console.log('can',can)

  // Textos centralizados
  const TEXTS = {
    defaultPressure: translate('defaultPressure'),
    belowThreshold: (pressOff) => `${translate('belowThreshold')} ${pressOff} [bar]`,
    hysteresis: (pressRecovery) =>`${translate('hysteresis')} ${pressRecovery} [bar]`,
    blocking: (pressOff) => `\n${translate('blocking')}: ${pressOff} [bar]`,
    failSensor: translate('sensor_failure'),
    unitVolt: (v) => `${v} V`,
    unitAmp: (a) => `${a} A`,
    unitBar: (p) => `${p} bar`,
    unitSal: (s) => `${s} ppt`,
    controllerConnected: translate('controllerConnected'),
    controllerDisconnected: translate('controllerDisconnected'),
    sourceConnected: translate('fuente'),
    sourceBattery: translate('sourceBattery'),
    noData: "--",
  };

  // memoizar tooltip y estilos
  // const { tooltipMessage, hasErrorBorder } = useMemo(() => {
  //   // let message = "Presión de rango en operación.";
  //   let message = TEXTS.defaultPressure;
    
  //   if (can.presion_histeresis) {
  //     if (can.presion < pressOff) {
  //       // message = `Presión por debajo del umbral mínimo ${pressOff} [bar]`;
  //       message = TEXTS.belowThreshold(pressOff);
  //     } else if (can.presion < pressRecovery) {
  //       // message = `Presión en histéresis, reactivación a ${pressRecovery} [bar]`;
  //       message = TEXTS.hysteresis(pressRecovery);
  //     }
  //   } else {
  //     // message += `\nPresión de bloqueo: ${pressOff} [bar]`;
  //     message += TEXTS.blocking(pressOff);
  //   }

  //   return {
  //     tooltipMessage: message,
  //     hasErrorBorder: !can.source, // antes: "solid 0.01vw rgb(240, 42, 42)"
  //   };
  // }, [can.presion, can.presion_histeresis, can.source, pressOff, pressRecovery]);
  const { tooltipMessage, hasErrorBorder, pressureClass } = useMemo(() => {
    let message = TEXTS.defaultPressure;
    let isBelowThreshold = false;

    // Si existe presion_histeresis
    if (can.presion_histeresis) {
      if (can.presion < pressOff) {
        message = TEXTS.belowThreshold(pressOff);
        isBelowThreshold = true;
      } else if (can.presion < pressRecovery) {
        message = TEXTS.hysteresis(pressRecovery);
      }
    } 
    // Si NO existe presion_histeresis
    else {
      if (can.presion < DEFAULT_PRESS_RECOVERY) {
        message = TEXTS.belowThreshold(DEFAULT_PRESS_RECOVERY);
        isBelowThreshold = true;
      } else {
        message += TEXTS.blocking(pressOff);
      }
    }

    return {
      tooltipMessage: message,
      hasErrorBorder: !can.source,
      pressureClass: isBelowThreshold ? "qd-text--error" : ""
    };
  }, [can.presion, can.presion_histeresis, can.source, pressOff, pressRecovery]);
  
  // Revisa bombas del CAN
  const allBombasNull = Array.isArray(can.bombas) &&
    can.bombas.length > 0 &&
    can.bombas.every(
      (b) =>
        b.O2_bckp === null &&
        b.SO2_bckp === null &&
        b.TEMP_bckp === null &&
        b.O2 === null &&
        b.SO2 === null &&
        b.TEMP === null
    );

  // 🎨 Color de fondo
  let bgColor = "linear-gradient(to top, rgb(20, 30, 48), rgb(36, 59, 85))"; // normal
// console.log('can', can)
  if (!can) return null;

  return (
    <div className="qd-container" /* width total */>
      {/* Bloque de métricas */}
      <div  className={`qd-card qd-metrics ${hasErrorBorder ? "qd-error" : ""}`}>
        {/* Voltaje */}
        <span className="qd-text">
          {/* {isNaN(can.voltaje) || can.voltaje === null ? "--" : `${can.voltaje} V`} */}
          {isNaN(can.voltaje) || can.voltaje === null ? TEXTS.noData : TEXTS.unitVolt(formatNumber(can.voltaje))}
        </span>

        {/* Corriente */}
        <span className="qd-text">
          {/* {isNaN(can.corriente) || can.corriente === null ? "--" : `${can.corriente} A`} */}
          {isNaN(can.corriente) || can.corriente === null ? TEXTS.noData : TEXTS.unitAmp(formatNumber(can.corriente))}
        </span>

        {/* Presión */}
        {can.presion < 0 ? (
          <span className="qd-text qd-text--error">{TEXTS.failSensor}</span>
        ) : (
          <CustomTooltip title={tooltipMessage} color="primary">
            <span
              // className={`qd-text ${can.presion_histeresis ? "qd-text--error" : ""}`}
              className={`qd-text ${pressureClass}`}
            >
              {/* {isNaN(can.presion) ? "--" : `${can.presion} bar`} */}
              {can.presion == null || isNaN(can.presion)  ? TEXTS.noData : TEXTS.unitBar(formatNumber(can.presion))}
            </span>
          </CustomTooltip>
        )}

        {/* Salinidad */}
        <span className="qd-text">
          {/* {isNaN(can.sal) ? "--" : can.sal < 0 ? "Falla Sensor" : `${can.sal} ppt`} */}
          {isNaN(can.sal) || can.sal === null ? TEXTS.noData : can.sal < 0 ? TEXTS.failSensor : TEXTS.unitSal(formatNumber(can.sal))}

        </span>

        {/* Estado conexión tarjeta */}
        { tieneDatosCompletos &&
          <CustomTooltip
            title={ can.estado ? TEXTS.controllerConnected : TEXTS.controllerDisconnected }
            color="primary"
          >
            <div className="qd-icon-wrap">
              {can.estado ? (
                <SensorsRoundedIcon className="qd-icon qd-icon--ok" />
              ) : (
                <SensorsOffRoundedIcon className="qd-icon qd-icon--err" />
              )}
            </div>
          </CustomTooltip>
        }

        {/* Estado fuente/batería */}
        <CustomTooltip
          // title={can.source ? "Conectado a la fuente" : "Consumiendo batería de respaldo"}
          title={ can.source ? TEXTS.sourceConnected : TEXTS.sourceBattery }
          color="primary"
        >
          <div className="qd-icon-wrap">
            {can.source ? (
              <PowerIcon className="qd-icon" />
            ) : (
              <BatterySaverIcon className="qd-icon" />
            )}
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
}

export default React.memo(QuadrantDetail);
